import config from '../config/configureEnv';
import {
  ajax,
  getUserAuthDataFromLocalStorage,
} from '../utils';

export default {
  uploadUserFile: (formData, { assessmentId }) => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken } = userAuthData;
    return ajax('POST', `${config.bocaAPIUrl}/user-surveys/${assessmentId}/upload`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },

  getFileList: (assessmentId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/user-surveys/${assessmentId}/customFiles`, {
      urlParams: { access_token: accessToken },
    });
  },

  getDownloadURL: ({ assessmentId, fileId }) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/user-surveys/${assessmentId}/customFiles/${fileId}`, {
      urlParams: { access_token: accessToken },
    });
  },

  deleteFile: ({ assessmentId, fileId }) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('DELETE', `${config.bocaAPIUrl}/user-surveys/${assessmentId}/customFiles/${fileId}`, {
      urlParams: { access_token: accessToken },
    });
  },

  getPhotoDownloadURL: (url) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/${url}`, {
      urlParams: { access_token: accessToken },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/FileAPIConnectors.js